import React, { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { useQueryParams } from '@fs/zion-router'
import { groupWorkflowActionsQuery } from '../hooks/useCoverages.utils'

export const GroupWorkflowActionsContext = React.createContext({})

export default function GroupWorkflowActionsProvider({ children }) {
  const queryParams = useQueryParams()
  const { query } = queryParams

  // originally coverages where workflow actions are used were not being used in image quality audit so we'll skip it here
  const {
    data: WFAData,
    error: WFAError,
    loading: WFALoading,
  } = useQuery(groupWorkflowActionsQuery(), {
    variables: { groupIds: [query.groupId] },
    skip: query?.mode === 'imageQualityAudit' || !query?.groupId,
    fetchPolicy: 'network-only',
  })

  const groupWorkflowActionsContextValue = useMemo(
    () => ({
      data: WFAData,
      error: WFAError,
      loading: WFALoading,
    }),
    [WFAData, WFAError, WFALoading]
  )

  return (
    <GroupWorkflowActionsContext.Provider value={groupWorkflowActionsContextValue}>
      {children}
    </GroupWorkflowActionsContext.Provider>
  )
}
